import { createReducer } from 'pobble-components/dist/redux-helpers'

let defaultState = {
  opened: false,
  ids: []
}

const AddToGroupDialog = createReducer(defaultState, {
  'ADD_TO_GROUP_DIALOG:OPEN': (state, { ids }) => ({
    ...defaultState,
    opened: true,
    ids
  }),
  'ADD_TO_GROUP_DIALOG:CLOSE': state => ({ ...state, opened: false })
})

export default AddToGroupDialog
